module.exports = __webpack_public_path__ + "dashboard.95cc506e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/media/headers/dashboard.png
// module id = 1732
// module chunks = 0